import DataTable from "react-data-table-component";
import ContentPage from "../../Content";
import { Link, useNavigate } from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import SwalTopEnd from "../../../utils/swal_top_end";
import BaseUrl from "../../../utils/BaseUrl";
import CustomerStyle from "../../../utils/customerStyle";
import { UserContext } from "../../../utils/User_check";
import can from "../../../utils/Can";


const url = BaseUrl();
const customStyles = CustomerStyle();
function GroupePermissionPage(){
    const [errors,setErrors] = useState({});

    const [loading, setLoading] = useState(false);
    const [permission,setPermission]  = useState([])
    const [permissionData,setPermissionData] = useState({
        'name':''
    });
    const [name,setName] = useState('');
    const [itemsList,setItemsList] = useState([]);
    const [itemsListFilter,setItemsListFilter] = useState([]);

    const columns = [
        {
            name: 'ID',
            selector: (row,index) => index+1,
            sortable: true,
        },
        {
          name: 'LIBELLE',
          selector: row => row.name,
          sortable: true,
        },
    
        // {
        //     name: "Action",
        //     selector : row => (
        //         <>
        //             <button className="btn btn-primary btn-sm mx-1" onClick={()=>update_modal(row)}><i class="fa-solid fa-pen"></i></button>
        //             <button className="btn btn-danger btn-sm" onClick={()=>deleteItem(row.id)}><i class="fa-solid fa-trash"></i></button>
        //         </>
        //     )
        //   },

    ];
    const {user,role, permissions} = useContext(UserContext);
    const navigate = useNavigate();
    useEffect(()=>{
    if(user && permissions && !can(permissions,'LISTE DES ROLES ET PERMISSIONS')){
        navigate('/page-no-found');
    }
    },[user]);
    
    useEffect(()=>{
        fetchPermissionList();
    },[]);

    const fetchPermissionList = async ()=>{
        setLoading(true);
        try {
            axios.get(url.base+'/groups-list',{
                headers:{
                    'Content-Type':'application/json',
                    "Authorization": `Bearer ${localStorage.getItem('_token_')}`
                    
                },
            }).then((resp)=>{

                if(resp.status == 200){
                    setItemsList(resp.data.data);
                    setItemsListFilter(resp.data.data);
                }
                setLoading(false);
            })
        } catch (error) {
            setLoading(false);
        }
    }

    
    const handleChange=(e)=>{
        setPermissionData({
            ...permissionData,
            [e.target.name]:e.target.value
        });
    }

    const submitForm= (e)=>{
        e.preventDefault();

        const _formData = new FormData();
        _formData.append('name',permissionData.name);

        setLoading(true);
        try {
            axios.post(url.base+'/groups-store',_formData,
            {
                headers:{
                    'Content-Type':'application/json',
                    "Authorization": `Bearer ${localStorage.getItem('_token_')}`
                    
                },
                // credentials:'include'
            }
            ).then((resp)=>{
                setLoading(false);
                if(resp.status == 200){
                    // console.log(resp.data);
                    setErrors({});

                    SwalTopEnd({icon:'success',title:"Enregistrement effectué avec succès!"})
                    //   window.$("#exampleModal-2").modal('hide');
                      setPermissionData({
                        'name':''
                      });
                      fetchPermissionList();
                }else{
                    SwalTopEnd({icon:'error',title:"Désolé un problème est subvenu."})
                }
            }).catch((error)=>{                
                setLoading(false);
                setErrors(error.response.data.error);
            })
        } catch (error) {
            setLoading(false);
        }
    }

    const submitFormUpdate= (e)=>{
        e.preventDefault();

        const _formData = new FormData();
        _formData.append('name',name);

        setLoading(true);
        try {
            axios.post(url.base+'/groups-update/'+permission.id,_formData,
            {
                headers:{
                    'Content-Type':'application/json',
                    "Authorization": `Bearer ${localStorage.getItem('_token_')}`
                    
                },
                // credentials:'include'
            }
            ).then((resp)=>{
                setLoading(false);
                if(resp.status == 200){
                    // console.log(resp.data);
                    setErrors({});

                    SwalTopEnd({icon:'success',title:"Modification effectué avec succès!"})
                    //   window.$("#exampleModalUpdate-2").modal('hide');
                      setPermissionData({
                        'name':''
                      });
                      fetchPermissionList();
                }else{
                    SwalTopEnd({icon:'error',title:"Désolé un problème est subvenu."})
                }
            }).catch((error)=>{                
                setLoading(false);
                setErrors(error.response.data.error);
            })
        } catch (error) {
            setLoading(false);
        }
    }

    const handleFilter=(event)=>{
        const datas = itemsListFilter.filter(row => row.name.toLowerCase().includes(event.target.value.toLowerCase()));
        setItemsList(datas);
    }


    const update_modal=(item)=>{
        setPermission(item);
        setName(item.name)
        window.$("#exampleModalUpdate-2").modal("show")
    }

    const add_modal=()=>{
        window.$("#exampleModal-2").modal("show")
    }

    return (
        <>
            <ContentPage>
            <div class="page-header flex-wrap">
        <div class="header-right d-flex flex-wrap mt-md-2 mt-lg-0">
            <div class="d-flex align-items-center">
              <a href="#">
                <p class="m-0 pr-3">Paramètres</p>
              </a>
              <a class="pl-3 mr-4" href="#">
                <p class="m-0">Listes des groupe permissions</p>
              </a>
            </div>
            {/* <button type="button" class="btn btn-primary mt-2 mt-sm-0 btn-icon-text">
              <i class="mdi mdi-plus-circle"></i> Add Prodcut </button> */}
          </div>
          <div class="header-left">
            {/* <button class="btn btn-primary mb-2 mb-md-0 mr-2"  onClick={add_modal}> Ajouter </button> */}
            {/* <button class="btn btn-outline-primary mb-2 mb-md-0"> Import documents </button> */}
          </div>
          
        </div>

        <div class="col-lg-12 grid-margin stretch-card">
            <div class="card">
            <div class="card-header bg-warning bg-gradient">
                  <div class="row">
                      <div class=" col-lg-3 col-md-6">
                          <input type="search" class="form-control " placeholder="Reference..." onChange={handleFilter}/>
                      </div>
              </div>
              </div>
              <div class="card-body">
                <h4 class="card-title">GROUPE DE PERMISSIONS</h4>
                <div class="table-responsive">
                <DataTable 
                      columns={columns} 
                      data={itemsList}
                      customStyles={customStyles}
                      pagination
                      selectableRows
                      progressPending={loading}
                      progressComponent={
                          <>
                          <div class="text-center">
                              <div class="spinner-border" role="status">
                              {/* <span class="visually-hidden">Loading...</span> */}
                              </div>
                          </div>
                          </>
                      } 
                  />
                </div>
              </div>
            </div>
          </div>

          <div class="modal fade" id="exampleModal-2" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                    <div class="modal-dialog" role="document">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title" id="exampleModalLabel">Ajouter un groupe</h5>
                                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
                                    {/* <span aria-hidden="true">&times;</span> */}
                                </button>
                            </div>
                            <form onSubmit={submitForm}>
                                <div class="modal-body">
                                
                                <div class="mb-3">
                                    <label class="form-label" for="textInput">Libelle </label>
                                    <input type="text" id="textInput" class="form-control" name="name" onChange={handleChange} value={permissionData.name} placeholder="Saisissez le libelle " />
                                    {errors && errors.per_libelle && (
                                        <span className="text-danger">{errors.name[0]}</span>
                                    )}
                                </div>
                                
                                </div>
                                <div class="modal-footer">
                                    <button type="button" class="btn btn-secondary btn-sm" data-bs-dismiss="modal">Fermer</button>
                                    
                                    {!loading && <button type="submit" class="btn btn-primary btn-sm">Enregistrer</button>}
                                    {loading && <button class="btn btn-primary btn-sm" type="button" disabled>
                                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                                Chargement...
                                            </button>}
                                    
                                    
                                </div>
                            </form>
                        </div>
                    </div>
            </div>

            <div class="modal fade" id="exampleModalUpdate-2" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                    <div class="modal-dialog" role="document">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title" id="exampleModalLabel">Modfier le groupe</h5>
                                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
                                    {/* <span aria-hidden="true">&times;</span> */}
                                </button>
                            </div>
                            <form onSubmit={submitFormUpdate}>
                                <div class="modal-body">
                                
                                <div class="mb-3">
                                    <label class="form-label" for="textInput">Libelle</label>
                                    <input type="text" class="form-control" onChange={(e)=>setName(e.target.value)} value={name} placeholder="Saisissez le libelle " />
                                    {errors && errors.per_libelle && (
                                        <span className="text-danger">{errors.name[0]}</span>
                                    )}
                                </div>
                                
                                </div>
                                <div class="modal-footer">
                                    <button type="button" class="btn btn-secondary btn-sm" data-bs-dismiss="modal">Fermer</button>
                                    
                                    {!loading && <button type="submit" class="btn btn-primary btn-sm">Modifier</button>}
                                    {loading && <button class="btn btn-primary btn-sm" type="button" disabled>
                                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                                Chargement...
                                            </button>}
                                    
                                    
                                </div>
                            </form>
                        </div>
                    </div>
            </div>
            </ContentPage>
        </>
    )
}

export default GroupePermissionPage;